import { Component, EventEmitter, ElementRef, ViewChild, AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { ModalAlertService } from '../../modules/modals/alert-window';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../service/data/data.service';
import { UploadCargaService } from '../../service/upload-carga/upload-carga.service';

@Component({
  selector: 'app-upload-carga',
  templateUrl: './upload-carga.component.html',
  styleUrls: ['./upload-carga.component.css'],
  providers: [UploadCargaService]
})
export class UploadCargaComponent implements OnInit {
  public data: any;
  public hasFile: boolean = false;
  private isRessarcimento: number;
  private email: string;
  public exibeMsgExtensao: boolean = false;
  public msgExtensao: string = "Extensão inválida. Selecione um arquivo com a extensão csv";

  constructor(private activatedRoute: ActivatedRoute,
    private alertModalService: ModalAlertService,
    private uploadCargaService: UploadCargaService,
    private dataService: DataService) {
  }

  ngOnInit() {
    this.dataService.currentUserDetails.subscribe(userDetails => {
      this.isRessarcimento = userDetails.is_Ressarcimento;
      this.email = userDetails.email;
    });

    this.ListaCarga();
  }

  onChangeFile(file) {    
    var extensao = file[0].name.split('.').pop();
    if (extensao == 'csv') {
      this.exibeMsgExtensao = false;
      this.hasFile = true;
    }
    else {
      this.exibeMsgExtensao = true;
      this.hasFile = false;
    }
      
  }

  ListaCarga() {

    this.dataService.currentUserDetails.subscribe(userDetails => {
      this.uploadCargaService.ListaCarga(this.isRessarcimento).subscribe((res) => {
        this.data = res;
      });

    });
    
  }

  downloadLog(isCarga: number) {
    window.open("api/upload/LogCritica/" + isCarga);
    /*this.uploadCargaService.logCritica(isCarga).subscribe((res) => {
      alert(res);
    });*/
  }

  upload(files) {
    if (files.length === 0)
      return;
    
    const formData = new FormData();
    formData.append(files[0].name, files[0]);

    this.uploadCargaService.uploadFile(formData, this.isRessarcimento, this.email).subscribe((res: any) => {
      if (res.statusRetorno < 1) 
        this.alertModalService.show("Atenção", res.mensagemRetorno);

      this.ListaCarga();
    });
  }  
}
